<template>
  <div>
    <div>
      <!-- page meta -->
      <Head>
        <title>
          Platforma - Collect and Analyze Member Data To Sell More Products
        </title>
        <link
          rel="icon"
          :href="$filters.public_path('favicon.png')"
          type="favicon"
        />
        <meta
          name="description"
          content="Make informed business decesions about your audience when you have all the data."
        />
      </Head>
    </div>
    <!-- content start -->

    <div
      class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
    >
      <!-- ===================== HERO SECTION ===================== -->

      <section
        id="section1"
        class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
        :style="backgroundImageStyleMain"
      >
        <div class="mt-0 bg-transparent px-[25px] xl:px-0">
          <h1
            class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[45px]"
          >
            Advanced analytics and member data<br />is here.
          </h1>

          <p
            class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
          >
            Get real-time data to analyze and improve your platform’s
            performance.
          </p>

          <!-- captcher email widget -->

          <EmailCaptureHeaderWidget />

          <img :src="$filters.media_path('/images/stars.svg')" alt="" />
        </div>

        <div class="mb-[30px] mt-[30px] lg:mt-0 z-10 px-[15px]">
          <video
            class="lg:max-w-[628px] lg:mt-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/google-level-analytics-for-your-membership-site-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <div
        class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
      >
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
        <h2
          class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
        >
          JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
        </h2>
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      </div>

      <!-- ===================== MEMBER ACTIVITY SECTION===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="$filters.media_path('/images/blue_gradient.svg')"
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_member_activity"
              class="text-xs font-extrabold text-[#2D8CFF]"
            >
              MEMBER ACTIVITY
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Track every move to optimize the community.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Every member comes complete with an activity log to follow along
              their movement as they progress in the space.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <video
              class="lg:max-w-[648px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
              id="home_video"
              loop
              muted
              autoplay
              playsinline
            >
              <source
                :src="
                  $filters.media_path(
                    '/videos/member-tracking-for-membership-site-com.mp4'
                  )
                "
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </section>

      <!-- ===================== LOGS SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
      >
        <img
          class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
          :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
          alt=""
        />

        <div
          class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
        >
          <div
            id="text_logs"
            class="text-xs font-extrabold text-[#27AE60] lg:left-0"
          >
            LOGS
          </div>

          <h2
            class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Login sessions show times and I.P. addresses.
          </h2>

          <div class="">
            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
            />
          </div>

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            See location, device, ip addresses, time, and more...for each member
            in your hub.
          </p>
        </div>

        <div
          class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
        >
          <video
            class="lg:max-w-[648px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/member-sessions-for-tracking-customers-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <!-- ===================== PROGRESS SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[125px] lg:flex lg:h-[550px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="
            $filters.media_path('/images/platforma_turqoise_diamond_bg.svg')
          "
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_progress"
              class="text-xs font-extrabold text-[#49CCF9]"
            >
              PROGRESS
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Course progress to verify consumption.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#49CCF9] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Comes in handy to see how far students got through a course.
              Whether its course optimization, confirm retention, or have proof
              for payment disputes. Make data work for you.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="lg:w-[645px]"
              :src="
                $filters.media_path(
                  '/images/member-online-course-progress-tracking.png'
                )
              "
              alt="See the progress of all your members as they progress through your courses."
            />
          </div>
        </div>
      </section>
    </div>

    <!-- ===================== CTA BLOCK ===================== -->
    <CtaBlock
      cta-headline="Start using Platforma Courses 
and make more every month."
    />
  </div>
</template>
<!-- =======CONTENT END======== -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    // ButtonComponent,
    EmailCaptureHeaderWidget,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
